var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNkn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.02 10.128c-1.003-.415-3.133-1.846-3.631-4.253-.5-2.406.276-4.253.725-4.875 1.003.519 3.133 1.95 3.63 3.527.623 1.97.372 6.223-.726 5.6zm-1.35 1.452c-.864-1.21-3.298-3.755-6.12-4.253-2.82-.498-6.36 1.245-7.779 2.179.624 1.452 2.781 4.398 6.433 4.564 3.65.166 6.5-1.59 7.468-2.49zm-5.393-8.505c1.162 1.078 1.314 2.662 1.245 3.319-4.98 0-5.256-3.181-4.772-4.772.692.035 2.365.374 3.527 1.453zm-4.15 12.677c-.414 1.003-1.845 3.133-4.252 3.63-2.406.498-4.253-.276-4.875-.726.519-1.002 1.95-3.132 3.527-3.63 1.97-.622 6.223-.372 5.6.726zm1.453 1.349c-1.21.865-3.755 3.3-4.253 6.12-.498 2.822 1.245 6.362 2.179 7.78 1.452-.622 4.398-2.78 4.564-6.431.166-3.652-1.59-6.501-2.49-7.47zm-8.505 5.394c1.078-1.161 2.662-1.313 3.319-1.244 0 4.979-3.181 5.255-4.772 4.771.035-.69.374-2.364 1.453-3.526zm19.83-2.193c-2.347 1.644-5.868 1.565-7.335 1.32.049-1.32.822-4.576 3.52-7.04 2.7-2.465 6.308-1.908 7.775-1.32-.342 1.662-1.613 5.398-3.96 7.04zm-1.687 3.741c-2.054-1.348-4.572-.855-5.575-.439-1.216.337 1.614 3.522 3.448 4.475 1.468.763 3.986.27 5.062-.073-.123-.758-.88-2.611-2.934-3.96zm.953-1.686c.417.514 1.644 1.526 3.228 1.467 1.585-.057 3.008-1.001 3.52-1.466-.781-1.467-3.226-3.52-6.747 0z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNkn);
export default __webpack_public_path__ + "static/media/NKN.46fcd00f2f8000980068911cf8b7bf08.svg";
export { ForwardRef as ReactComponent };